import React from 'react';
import Tooltip from '@/components/common/Tooltip';
import StandardButton from '@/components/ui/Buttons/StandardButton';

interface RunSyncButtonProps {
  districtDisabled?: boolean;
  hasRunningSync?: boolean;
  openRunModal: () => void;
}

const RunSyncButton = ({
  districtDisabled = false,
  hasRunningSync = false,
  openRunModal,
}: RunSyncButtonProps) => {
  const isDisabled = districtDisabled || hasRunningSync;
  const buttonText = hasRunningSync ? 'Sync In Progress' : 'Run Sync';

  const button = (
    <StandardButton
      outlineStyle
      small
      disabled={isDisabled}
      onClick={openRunModal}
    >
      <i aria-hidden="true" className="fa fa-play" />
      {' '}
      {buttonText}
    </StandardButton>
  );

  if (isDisabled) {
    const tooltipText = districtDisabled
      ? 'Sync must be enabled.'
      : 'Only one roster sync can run at a time.';

    return (
      <Tooltip content={tooltipText}>
        <div className="inline_block">
          {button}
        </div>
      </Tooltip>
    );
  }

  return button;
};

export default RunSyncButton;
